<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Banners"
    :submit="submit"
    :status="status"
    :breadcrumbs="[
        {
          text: 'Marketing y comunicación',
          disabled: false,
          href: '/admin/banners'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: $route.params.id ? 'Editar' : 'Crear',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col>
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Título</div>
                <v-text-field
                solo
                    hide-details="auto"
                    class="input-base"
                  :error-messages="errors"
                  v-model="data.title"
                  label="Título"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="subtitle" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Subtítulo</div>
                <v-text-field
                solo
                    hide-details="auto"
                    class="input-base"
                  :error-messages="errors"
                  v-model="data.subtitle"
                  label="Subtítulo"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider ref="url" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Url</div>
                <v-text-field
                solo
                    hide-details="auto"
                    class="input-base"
                  :error-messages="errors"
                  v-model="data.url"
                  label="Url"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row class="mt-2" no-gutters>
            <v-col>
              <ValidationProvider
                ref="banner_picture"
                rules=""
                v-slot="{ errors }"
              >   <div class="label-base pb-1">Foto</div>
                <Upload
                  :error-messages="errors"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Foto"
                  prepend-icon="fas fa-camera"
                  label=""
                  :multiple="false"
                  :onSelectedPicture="onSelectedPicture"
                ></Upload>
                <v-img
                  :src="banner_picture"
                  width="200"
                  style="margin: auto"
                ></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import Upload from "@/components/Upload";
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: { ValidationProvider, ValidationObserver, CrudForm, Upload },
    computed: {
      ...mapState({
        status: state => state.Banners.status,
      })
    },
    data() {
      return {
        storeName: 'Banners',
        title: "Banners",
        filteredAttributes: ["banner_picture"],
        banner_picture: '',
        data: {
          title: '',
          subtitle:'',
          url:'',
          banner_picture: undefined,
        }
      }
    },
    methods: {
      onSelectedPicture(file) {
        const self = this;
        this.data.banner_picture = file;

        let fr = new FileReader();
        fr.onload = function() {
          self.banner_picture = fr.result;
        };
        fr.onerror = function() {
          self.banner_picture = "";
        };
        fr.readAsDataURL(this.data.banner_picture);
      },
    },
  }
</script>
